import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import { FooterConstants, LogoConstants } from '@/src/shared/constants/CommonConstants';
import { labelColor } from '@/src/styles/theme/lightThemeOptions';
import { getBlobUrl } from '@/src/utils/commonUtil';

import { FooterBox, FooterItems } from './style';

export const Footer = () => {
    const { t } = useTranslation(['footer']);
    const footerImage = getBlobUrl(LogoConstants.companyLogo);
    const privacyPolicyUrl = getBlobUrl(FooterConstants.privacyPolicy, 'pdf', 'gingerbot/org');
    const releaseNotesUrl = getBlobUrl(FooterConstants.releaseNotes, 'pdf', 'gingerbot/org');

    return (
        <FooterBox data-testid="footer">
            <ul className="footer">
                <FooterItems>
                    <Link
                        href="mailto:agnes@asfinag.at"
                        style={{ textDecoration: 'none', color: labelColor }}
                    >
                        {t('feedback')}
                    </Link>
                </FooterItems>
                <FooterItems>
                    <Link
                        href={privacyPolicyUrl}
                        style={{ textDecoration: 'none', color: labelColor }}
                        target="_blank"
                    >
                        {t('privacy')}
                    </Link>
                </FooterItems>
                <FooterItems className="release-notes">
                    <Link
                        href={releaseNotesUrl}
                        style={{
                            textDecoration: 'none',
                            color: labelColor,
                            position: 'relative',
                        }}
                        target="_blank"
                    >
                        {t('release-notes')}
                    </Link>
                </FooterItems>
                <FooterItems>
                    <Link
                        href={'/things-you-must-know'}
                        style={{ textDecoration: 'none', color: labelColor }}
                    >
                        {t('newsletter')}
                    </Link>
                </FooterItems>
                <FooterItems className="desktop_only"></FooterItems>
            </ul>
            <Image
                src={footerImage}
                alt={LogoConstants.companyLogo}
                width={80}
                height={20}
                priority
                className="footer_logo"
            />
        </FooterBox>
    );
};
